import { Link, useNavigate } from "react-router-dom";
import { Button } from "../../../../components/button";
import Icon from "../../../../components/icon";
import { PencilIcon, PlusIcon, TrashIcon } from "@heroicons/react/24/outline";
import IconButton from "../../../../components/icon-button";
import { useActionState, useEffect } from "react";
import { deleteTemplate } from "../actions";

export function CreateTemplate() {
  return (
    <Link to={"/admin/email-templates/create"}>
      <Button className="mt-4">
        Create Template
        <Icon icon={PlusIcon} label="Create Feature" className="ml-1" />
      </Button>
    </Link>
  );
}


export function UpdateTemplate({ id }: { id: string }) {
  return (
    <Link to={`/admin/email-templates/edit/${id}`}>
      <IconButton label="Edit" icon={PencilIcon} />
    </Link>
  );
}

export function DeleteTemplate({ id }: { id: string }) {
  const navigate = useNavigate();

  const deleteTemplateWithId = deleteTemplate.bind(null, id);
  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    if (!window.confirm("Are you sure you want to delete this template?")) {
      e.preventDefault();
    }
  }
  const [state, formAction, isPending] = useActionState(deleteTemplateWithId, {
    success: false,
  });
  useEffect(() => {
    if (state.success) {
      navigate("/admin/email-templates?reload=true", { replace: true });
    }
  }, [state]);

  return (
    <form action={formAction} onSubmit={handleSubmit}>
      <IconButton label="Delete" icon={TrashIcon} loading={isPending}/>
    </form>
  );
}
